import { Controller } from "@hotwired/stimulus";

export class CertificationUploadImageController extends Controller {
  static targets = ["input", "label", "errorMessage", "preview"];

  connect() {
    this.image = null;
    this.objectUrl = null;
    this.originalSrc = this.previewTarget.getAttribute("src");
  }

  loadImage(event) {
    const file = event.target.files[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      this.cancel();
      this.errorMessageTarget.style.display = "block";
      return;
    }

    this.errorMessageTarget.style.display = "none";

    this.objectUrl = URL.createObjectURL(file);
    this.previewTarget.src = this.objectUrl;
    this.previewTarget.style.display = "block";
    this.labelTarget.style.display = "none";
  }

  loadFileDialog() {
    this.inputTarget.click();
  }

  cancel() {
    this.inputTarget.value = "";

    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
      this.objectUrl = null;
    }

    this.previewTarget.src = this.originalSrc || "";

    this.labelTarget.style.display = this.originalSrc ? "none" : "flex";
    this.errorMessageTarget.style.display = "none";
  }
}
